// import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
// import { Box, Button, Typography } from "@mui/material";
// import React from "react";
// import theme from "../../../../theme";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   backgroundColor: theme.palette.background.paper,
//   boxShadow: 24,
//   borderRadius: "4px",
//   padding: theme.spacing(3),
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   gap: theme.spacing(2),
// };

// export default function VehicleAddedModal({ 
//   open, handleClose,
//   isEditing = false
// }) {
//   return (
//     <Box sx={style}>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           width: "60px",
//           height: "60px",
//           borderRadius: "50%",
//           backgroundColor: theme.palette.primary.main,
//         }}
//       >
//         <ArticleOutlinedIcon
//           sx={{ color: theme.palette.background.paper, fontSize: "36px" }}
//         />
//       </Box>
//       <Typography
//         id="vehicle-added-modal-title"
//         variant="h6"
//         component="h2"
//         sx={{
//           color: theme.palette.text.primary,
//           fontWeight: 600,
//         }}
//       >
//         {isEditing ? (
//           "Vehicle edited successfully"
//         ) : (
//           "Vehicle Added Successfully"
//         )}
//       </Typography>
//       <Typography
//         id="vehicle-added-modal-description"
//         sx={{
//           color: theme.palette.text.disabled,
//           textAlign: "center",
//         }}
//       >
//         Next steps? Sit back and relax! We've got it covered.
//       </Typography>
//       <Button
//         onClick={handleClose}
//         variant="contained"
//         sx={{
//           backgroundColor: theme.palette.primary.main,
//           color: theme.palette.text.secondary,
//           paddingLeft: theme.spacing(3),
//           paddingRight: theme.spacing(3),
//           paddingTop: theme.spacing(1),
//           paddingBottom: theme.spacing(1),
//           "&:hover": {
//             backgroundColor: theme.palette.primary.dark,
//           },
//         }}
//       >
//         Let's Get Going
//       </Button>
//     </Box>
//   );
// }

import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from "../../../../theme";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CAR_STATUSES } from "../../../../utils/constants/carData";
import { routes } from "../../../../utils/constants/routes";
import { useLazyRelistCarQuery } from "../../../../toolkit/sellMyCar/sellMyCarApi";
import { setupAndNavigateToCarEstimateHandler } from '../../../../utils/methods/generalVehicleMethods';
import { setAlertDialog } from "../../../../toolkit/alertDialog/alertDialogSlice";
import { reducerPaths } from "../../../../app/reducerPaths";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  boxShadow: 24,
  borderRadius: "4px",
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
};

export default function VehicleAddedModal({ open, handleClose, car, images, isEditing = false, changeTabHandler }) {
  const { t } = useTranslation("vehicleAddedSuccessModal");

  const dispatch = useDispatch();
  const myGarage = useSelector((store) => store[reducerPaths.myGarage]);

  const navigate = useNavigate();

  const [relishCarApiHandler, relishCarApiData] = useLazyRelistCarQuery();

  const relistCarHandler = async (car) => {
    const res = await relishCarApiHandler({
      Vehicle_Id: car?.Vehicle_Id,
    });

    if (res?.error || ('status' in res?.data && !res?.data?.status)) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message: res?.data?.message || res?.data?.error?.message || `Some error occured!`,
        })
      );
    } else {
      setupAndNavigateToCarEstimateHandler({
        car,
        dispatch,
        navigate,
        images: myGarage?.forms?.gallery?.images,
      });

      // fetchPaginationDataHandler();
    }
  };

  console.log('VehicleAddedModal', car);

  return (
    <Box sx={style}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <ArticleOutlinedIcon
          sx={{ color: theme.palette.background.paper, fontSize: "36px" }}
        />
      </Box>

      <Typography
        id="vehicle-added-modal-title"
        variant="h6"
        component="h2"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 600,
        }}
      >
        {car?.car_label_status === CAR_STATUSES["unsold-car"] ? t(`Unsold car`) : isEditing ? t("vehicleEdited") : t("vehicleAdded")}
      </Typography>

      <Typography
        id="vehicle-added-modal-description"
        sx={{
          color: theme.palette.text.disabled,
          textAlign: "center",
        }}
      >
        {car?.car_label_status === CAR_STATUSES["unsold-car"] ? 
          t(`The status of you car is unsold. Would you like to Relist it?`) : 
          t("vehicleNextSteps")}
      </Typography>

      {car?.car_label_status !== CAR_STATUSES["unsold-car"] ? <Button
        onClick={() => {
          handleClose({
            car,
            dispatch,
            navigate,
            images: images || []
          });
        }}
        variant="contained"
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.secondary,
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
          paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
        }}
      >
        {t("letsGetGoing")}
      </Button> : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
          }}
        >
          <Button
            onClick={changeTabHandler}
            variant="contained"
            sx={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              border: `1px solid ${theme.palette.text.primary}`,
              paddingLeft: theme.spacing(3),
              paddingRight: theme.spacing(3),
              paddingTop: theme.spacing(1),
              paddingBottom: theme.spacing(1),
            }}
          >
            {t("Go to your garage")}
          </Button>

          <Button
            onClick={() => {
              relistCarHandler(car);
            }}
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.text.secondary,
              paddingLeft: theme.spacing(3),
              paddingRight: theme.spacing(3),
              paddingTop: theme.spacing(1),
              paddingBottom: theme.spacing(1),
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
            disabled={relishCarApiData?.isLoading}
          >
            {t("Relist car")}
          </Button>
        </Box>
      )}
    </Box>
  );
}
